import { BackgroundColor } from "./../../background/constants/background-types";
import { ProgressCircleSchemeDefinition } from "./progress-circle-types";
import * as AllColors from "../../../constants/colors";
import { toConstantCase } from "../../../utils/string-format";
import { createProgressCircleMapDefinition } from "../../../utils/scheme-helper";

function createSchemes() {
  let newSchemes: AllColors.ProgressCircleSchemeConfiguration<ProgressCircleSchemeDefinition> = {};

  AllColors.PROGRESS_CIRCLE_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      textColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      iconColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      backgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      progressBackgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_OPACITY_10`],
      progressColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_OPACITY_10`],
      iconColorOnHover: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      progressBackgroundColorOnHover: AllColors[`COLOR_${toConstantCase(element.schemeName)}_OPACITY_10`],
      progressColorOnHover: AllColors[`COLOR_${toConstantCase(element.schemeName)}_OPACITY_10`],
      progressSuccessColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_OPACITY_10`],
      iconSuccessColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`]
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });
  return newSchemes;
}
export const PROGRESS_CIRCLE_SCHEME_CONFIG: AllColors.ProgressCircleSchemeConfiguration<ProgressCircleSchemeDefinition> = createSchemes();

export const PROGRESS_CIRCLE_SCHEME_MAP: Map<BackgroundColor | "default", ProgressCircleSchemeDefinition> = new Map(
  Object.entries(createProgressCircleMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    PROGRESS_CIRCLE_SCHEME_CONFIG[config as string]
  ])
);
